import React, { useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';
import { AlertTriangle, Loader2 } from 'lucide-react';

export default function ConfirmDialog({ open, onOpenChange, title = 'Supprimer cet élément ?', description, confirmLabel = 'Supprimer', onConfirm, destructive = true }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try { await onConfirm(); onOpenChange(false); }
    catch (e) { /* keep open on error */ }
    finally { setLoading(false); }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl">
        <AlertDialogHeader>
          <div className="w-10 h-10 rounded-xl bg-[#FEF2F2] flex items-center justify-center mb-2">
            <AlertTriangle className="w-5 h-5 text-[#EF4444]" />
          </div>
          <AlertDialogTitle style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); handleConfirm(); }}
            className={destructive ? 'bg-[#EF4444] hover:bg-[#DC2626] text-white' : ''}
            disabled={loading}
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin mr-1" />}
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
